import React from 'react';
import './LoadingSpinner.css';

/**
 * Full-screen centered loading spinner with Athlete Blue gradient.
 * @param {string} message - Optional label under the spinner
 */
export default function LoadingSpinner({ message = 'Loading…', fullScreen = true }) {
  return (
    <div className={fullScreen ? "loading-spinner-overlay" : "loading-spinner-inline"}>
      <div className="loading-spinner-wrapper">
        <div className="loading-spinner-ring">
          <svg
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
            className="loading-spinner-svg"
          >
            <defs>
              <linearGradient id="spinnerGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%"   stopColor="#45B7FF" />
                <stop offset="50%"  stopColor="#0F5FFF" />
                <stop offset="100%" stopColor="#17324D" />
              </linearGradient>
            </defs>
            {/* Background track */}
            <circle
              cx="50" cy="50" r="40"
              fill="none"
              stroke="#E8F0FE"
              strokeWidth="8"
            />
            {/* Gradient arc */}
            <circle
              cx="50" cy="50" r="40"
              fill="none"
              stroke="url(#spinnerGradient)"
              strokeWidth="8"
              strokeLinecap="round"
              strokeDasharray="150 100"
              className="loading-spinner-arc"
            />
          </svg>
        </div>
        {message && <p className="loading-spinner-text">{message}</p>}
      </div>
    </div>
  );
}
